import { Button, Modal } from 'react-bootstrap';

const DateConfirmModal = ({ showModal, setShowModal, setSelectedDate, tempDate }) => {
    return (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton style={{ backgroundColor: "#212529" }}>
                <h5 style={{ color: "#fff" }}>Confirm Date Selection</h5>
            </Modal.Header>
            <div style={{ backgroundColor: "#212529", color: "#adb5bd" }} className="modal-body">
                <p>
                    Are you sure you want to select a date older than 15 days? Evidence
                    cannot be fetched from the recorder for that period.
                </p>
                <p>If you have footage clips handy, please proceed.</p>
            </div>
            <Modal.Footer style={{ backgroundColor: "#212529" }}>
                <Button variant="secondary" onClick={() => {
                    const now = new Date();
                    setSelectedDate(now);
                    setShowModal(false);
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    if (tempDate) setSelectedDate(tempDate);
                    setShowModal(false);
                }}>
                    Proceed
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DateConfirmModal